import type { Theme } from "../../types";
import styles from "./SectionDivider.module.scss";

interface SectionDividerProps {
  theme: Theme;
  label: string;
}

export function SectionDivider({ theme, label }: SectionDividerProps) {
  return (
    <div className={styles.wrapper}>
      <span className={styles.label} style={{ color: theme.muted }}>
        {label}
      </span>
      <span className={styles.line} style={{ borderColor: theme.rule }} />
    </div>
  );
}
